import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {GridVisibilityConfigModel, RestService, RestSimpleResponseParser, RestYiiPagination, RestYiiSort} from 'gelios-ng-admin-components';
import {HttpClient} from '@angular/common/http';
import {SingleUnitLogService} from './single-unit-log.service';
import {UnitLogModel} from '../../notification/unit-log-list/unit-log.model';
import {BASE_UNIT_LOG_PROVIDERS, UnitLogListBase} from '../../notification/unit-log-list/unit-log-list-base';
import {SingleUnitLogGridFilterModel} from './grid-filter/single-unit-log-grid-filter.model';
import {Observable, of} from 'rxjs';
import {BaseAvailableColumnsType} from '../../base/base-available-columns.type';

@Component({
  selector: 'app-single-unit-log',
  templateUrl: '../../base/base-list.component.html',
  providers: BASE_UNIT_LOG_PROVIDERS
})
export class SingleUnitLogComponent extends UnitLogListBase implements OnInit {
  protected unitIdInternal: number;
  public reloading = false;
  @HostBinding('class.section-content') false;
  timestampColumnWidth = 280;
  timestampFloatingFilterComponentParams = {
    suppressFilterButton: true,
    dateTimeRange: this.createGridFilterModel().fields.timestamp.value,
  };

  get unitId() {
    return this.unitIdInternal;
  }

  @Input() set unitId(value: number) {
    this.unitIdInternal = value;
    if (this.gridComponent && this.gridComponent.refreshGrid) {
      this.reloading = true;
      this.gridComponent.refreshGrid();
    }
    this.applyInitialGridFilter();
  }

  gridVisibilityConfig: GridVisibilityConfigModel = {
    gridConfig: {
      grid: true,
      tools: true,
      statusBar: !this.forDashboard,
    },
    settingWindow: {
      visible: false
    },
  };

  createGridFilterModel(): SingleUnitLogGridFilterModel {
    return new SingleUnitLogGridFilterModel(this.unitIdInternal);
  }

  createService(http: HttpClient, environmentVersion: string, environmentApiBasepoint: string): RestService<UnitLogModel> {
    return new SingleUnitLogService<UnitLogModel>(http,
      this.restFilterService,
      new RestYiiSort(),
      new RestYiiPagination(),
      new RestSimpleResponseParser(),
      environmentVersion,
      environmentApiBasepoint
    );
  }

  getAvailableColumns(): Observable<BaseAvailableColumnsType> {
    return of({
      id: this.allColumns.id,
      timestamp: this.allColumns.timestamp,
      type: this.allColumns.type,
      priority: this.allColumns.priority,
      source_type: this.allColumns.source_type,
      source_name: this.allColumns.source_name,
      description: this.allColumns.description,
      command_description: this.allColumns.command_description,
      processed_by_user_login: this.allColumns.processed_by_user_login,
      processed_comment: this.allColumns.processed_comment,
      processed_at_timestamp: this.allColumns.processed_at_timestamp,
    });
  }

  onModelUpdated() {
    this.reloading = false;
  }
}
